import type { ScenePreset } from "@cfg/brand-sdk";
import { absMaterial } from "./abs.ts";

/**
 * Brick plastic on a night bench: glossy moulded ABS (see abs.ts) in a dark
 * studio. A warm overhead softbox and two vertical strips draw the clearcoat
 * highlights, a cool back rim separates the Stud Orange part from the ink
 * stage, and the floor bounce is kept low so the model is the brightest thing
 * on screen. Grid is the 8 mm stud pitch, drawn faintly like a cutting mat.
 */
export const workshop: ScenePreset = {
  id: "workshop",
  material: ({ three, color }) => absMaterial(three, { color, wear: 0.8 }),
  environment: {
    intensity: 0.75,
    lightformers: [
      { form: "rect", intensity: 6, color: "#fff1e2", position: [-2, -3, 10], scale: [6, 8] },
      { form: "rect", intensity: 12, color: "#ffffff", position: [-7, -6, 3], scale: [2, 9] },
      { form: "rect", intensity: 10, color: "#cfe0ff", position: [8, -2, 2], scale: [1.5, 7] },
      { form: "rect", intensity: 9, color: "#b9d0ff", position: [0, 9, 4], scale: [10, 2] },
      { form: "rect", intensity: 0.25, color: "#212C3E", position: [0, 0, -8], scale: [16, 16] },
    ],
  },
  lights: {
    ambient: 0.04,
    hemisphere: { sky: "#e8eefc", ground: "#141C29", intensity: 0.25 },
    key: { intensity: 1.6, position: [80, -120, 160], color: "#fff1e2", castShadow: true },
    fill: { intensity: 0.35, position: [-140, -60, 80], color: "#c9d8f5" },
    rim: { intensity: 1.1, position: [40, 160, 120], color: "#a9c4ff" },
  },
  background: { gradient: ["#1F2A3B", "#111925"] },
  grid: { show: true, cellSize: 8, sectionSize: 40, color: "#2B3648", sectionColor: "#3A4458", infinite: true },
  shadows: true,
  toneMapping: "Neutral",
  exposure: 1.05,
  camera: { fov: 32, distanceFactor: 1.2, autoRotate: 0 },
};
